import RegDataProvider from 'global/cnr/contexts/RegDataContext';
import AppUsersProvider from '../cnr/contexts/AppUsersContext';
import DataWrapperProvider from '../cnr/contexts/DataWrapperContext';
import ManifestProvider from '../cnr/contexts/ManifestContext';
import PapsProvider from '../cnr/contexts/PapsContext';
import SearchParamProvider from '../cnr/contexts/SearchParamContext';
import ServiceWorkerProvider from '../cnr/contexts/ServiceWorkerContext';
import SettingsDataProvider from '../cnr/contexts/SettingsDataContext';
import AppView from './AppView';
import { ManifestWatcher } from 'ManifestWatcher';
import AppTimestampProvider from 'global/cnr/contexts/AppTimestampContext';
import DemoProvider from 'global/cnr/contexts/DemoContext';
import TimestampsProvider from 'global/cnr/contexts/TimestampsContext';
import SportsWrapper from 'projectSpecific/sports/elements/sports/SportsWrapper';
import PageManager from './PageManager';

const PrePapsProviders = ({ children }) => (
  <PapsProvider>
    <SearchParamProvider>
      <AppTimestampProvider>
        <TimestampsProvider>
          <DemoProvider>
            <RegDataProvider>
              {/* Home, Client, Event */}
              <SettingsDataProvider>
                <ManifestProvider>
                  <ServiceWorkerProvider>
                    <AppUsersProvider>
                      <DataWrapperProvider>
                        <ManifestWatcher />
                        {children}
                      </DataWrapperProvider>
                    </AppUsersProvider>
                  </ServiceWorkerProvider>
                </ManifestProvider>
              </SettingsDataProvider>
            </RegDataProvider>
          </DemoProvider>
        </TimestampsProvider>
      </AppTimestampProvider>
    </SearchParamProvider>
  </PapsProvider >
);

/** Starting point fo the Page
@componentContexts [StartContext, AuthContext, AppSettingContext]  
*/
function AppPaps() {
  // return <div style={{ color: 'white' }}>AppRoutes</d 
  return (
    <PrePapsProviders>
      <PageManager />
    </PrePapsProviders>
  )
}

export default AppPaps